/**
 * Created by mukund on 8/24/17.
 */
angular.module('mediacloudApp')
    .directive('multiUploader', ['$state', '$filter', '$location', '$rootScope', '$interval', '$window', '$timeout', '$http', 'BatchService', 'JobService', 'CollectionService', 'BaseFileService', 'ProfileService', 'Tenant', 'atmosphereService', 'UploadErrors', 'UploadLimits', 'CaptionTypeMessages', function($state, $filter, $location, $rootScope, $interval, $window, $timeout, $http, BatchService, JobService, CollectionService, BaseFileService, ProfileService, Tenant, atmosphereService, UploadErrors, UploadLimits, CaptionTypeMessages) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/upload/upload.html',
            scope: {
                account: '=',
                active: '='
            },
            link: function (scope, elem, attrs) {

                if(scope.account) {

                    // The maximum length of description for each asset.
                    scope.maxDescriptionLength = 255;

                    scope.selectedFileForDelete = null;
                    scope.defaultUploader = true;

                    if ($state.current.name === 'lmsCourse') {
                        scope.isLMSCourse = true;
                    }

                    scope.hideHeaderAndFooter = $rootScope.hideHeaderAndFooter;

                    scope.Math = $window.Math;

                    Tenant.info().then(function (tenant) {
                        scope.tenant = tenant;
                    });

                    // Every time the upload page is loaded, get the list of batches which haven't been published
                    var getUnpublishedBatches = function () {

                        JobService.GetUnpublished.query({autoPublish: false}, function (unpublishedJobs) {

                            angular.forEach(unpublishedJobs, function (unpublishedJob) {

                                var batch = unpublishedJob.baseFileEntity.batch,
                                    file = {
                                        fileId: unpublishedJob.baseFileEntity.fileId,
                                        jobId: unpublishedJob.jobId,
                                        progress: (unpublishedJob.baseFileEntity.publishStatus === 'READY' ? 100 : 0),
                                        uploadStatus: (unpublishedJob.baseFileEntity.publishStatus === 'READY' ? "File processing complete" : "Processing file... "),
                                        batchId: batch.batchId,
                                        mediacloudFileId: unpublishedJob.baseFileEntity.id,
                                        metadata: unpublishedJob.baseFileEntity.metadata,
                                        sendForCaptioning: unpublishedJob.baseFileEntity.sendForCaptioning,
                                        metaErrors: [],
                                        errors: [],
                                        uploadComplete: true,
                                        canBePublished: true
                                    };

                                // Call HotFolder to retrieve thumbnails
                                BaseFileService.GetBaseFile.get({id: file.fileId}, function (baseFile) {
                                    file.thumbnails = baseFile.thumbnails;
                                    file.selectedThumbnail = $filter('filter')(baseFile.thumbnails, {id: unpublishedJob.baseFileEntity.thumbnailId})[0];
                                    file.name = baseFile.name;
                                    var fileExt = baseFile.name.substring(baseFile.name.lastIndexOf('.') + 1);
                                    file.needsTranscoding = !(UploadLimits.NO_TRANSCODE_FILE_TYPES.indexOf(fileExt.toLowerCase()) > -1);
                                }, function () {
                                    file.metaErrors.push({
                                        id: 'fme' + Date.now(),
                                        msg: UploadErrors.GET_PREV_FILE_THUMBS
                                    });
                                });

                                if (file.metadata && file.metadata.captionType) {
                                    if (file.metadata.captionType === 'WATSON') {
                                        file.captionStatus = CaptionTypeMessages.WATSON;
                                    } else if (file.metadata.captionType === 'EMBEDDED') {
                                        file.captionStatus = CaptionTypeMessages.EMBEDDED;
                                    } else {
                                        file.captionStatus = ""
                                    }
                                } else {
                                    file.captionStatus = ""
                                }

                                var savedBatch = $filter('filter')(scope.batches, {batchId: batch.batchId}, true);
                                if (!savedBatch || savedBatch.length === 0) {
                                    batch.position = scope.batches.length + 1;
                                    batch.name = "Batch " + batch.position;
                                    batch.files = [];
                                    batch.metaErrors = [];
                                    batch.errors = [];
                                    batch.progress = 0;
                                    batch.transcodedCnt = 0;
                                    batch.size = batch.files.length;
                                    batch.uploadedFilesCnt = batch.size;
                                    scope.batches.unshift(batch);
                                } else {
                                    batch = savedBatch[0];
                                }
                                file.showDeleteAction = false;
                                batch.files.push(file);
                                batch.size = batch.files.length;
                                batch.uploadedFilesCnt = batch.size;
                                if (file.progress == 100) {
                                    batch.transcodedCnt++;
                                }
                                batch.progress = Math.floor(batch.transcodedCnt * 100 / batch.size);

                            });

                            angular.forEach(scope.batches, function (batch) {
                                BatchService.GetBatchSummary.get({id: batch.batchId}, function (batchSummary) {
                                    processBatchSummary(batchSummary);
                                    batch.publishReady = batch.files.every(function (file) {
                                        return file.progress === 100;
                                    });
                                });
                                batch.sendForCaptioning = batch.files.every(function (file) {
                                    return file.sendForCaptioning;
                                });
                            });

                            $http({
                                method: 'GET',
                                url: 'api/properties?name=FEATURE_FLAG_DEFAULT_UPLOADER'
                            }).then(function successCallback(response) {
                                if (response.data.value != null) {
                                    scope.defaultUploader = response.data.value === 'true';
                                }
                            });

                            $http({
                                method: 'GET',
                                url: 'api/properties?name=NOTIFICATION_URL'
                            }).then(function successCallback(response) {
                                scope.notificationUrl = response.data.value;
                                console.log("notification URL: ", scope.notificationUrl);
                                atmosphereSetup();
                            });

                        }, function () {
                            scope.errors.push({id: 'ue' + Date.now(), msg: UploadErrors.GET_PREV_BATCHES});
                            atmosphereSetup();
                        })
                    };

                    var resetUploader = function(){
                        // An object that stores several global counts used for tracking purposes during the lifecycle of the upload process
                        scope.tracker = {uploader: 1, uploadingBatches: 0};

                        scope.errors = [];
                        scope.batches = [];

                        getUnpublishedBatches();
                    };

                    resetUploader();

                    // Only used by PnP version of uploader
                    scope.$watch('active', function(){
                        if(scope.active){
                            if(scope.active == 'upload') {
                                // Reset the uploader when switching between upload and other states within PnP
                                if(scope.tracker.uploadingBatches === 0) {
                                    resetUploader();
                                }
                            } else if (scope.tracker.uploadingBatches > 0) {
                                // Throw a warning if the user attempts to switch out of the uploader within PnP while files are uploading
                                var answer = confirm("Some files are still being uploaded and these uploads will fail if you leave this page. Are you sure you want to leave ?");
                                if (!answer) {
                                    scope.active = 'upload';
                                    event.preventDefault();
                                }
                            }
                        }
                    });

                    // For accessible modals
                    var modalFocus = function (first, last) {
                        var firstItem = $(first),
                            lastItem = $(last);

                        /*set focus on first item*/
                        firstItem.focus();

                        /*redirect last tab to first input*/
                        lastItem.on('keydown', function (e) {
                            if ((e.which === 9 && !e.shiftKey)) {
                                e.preventDefault();
                                firstItem.focus();
                            }
                        });

                        /*redirect first shift+tab to last input*/
                        firstItem.on('keydown', function (e) {
                            if ((e.which === 9 && e.shiftKey)) {
                                e.preventDefault();
                                lastItem.focus();
                            }
                        });
                    };

                    var processBatchSummary = function (batchSummary) {

                        var batch = $filter('filter')(scope.batches, {batchId: batchSummary.id}, true)[0],
                            transcodedCount = 0,
                            totalProgress = 0;

                        if (batch) {

                            batchSummary.jobSummary.forEach(function (jobSummary) {
                                var tasksTerminated = 0;
                                var canBePublished = false;
                                var captioningProviderLimitReached = false;
                                var file = $filter('filter')(batch.files, {jobId: jobSummary.id}, true)[0];
                                if (file) {
                                    jobSummary.tasks.forEach(function (task) {
                                        if (!(task.status === 'WAITING' || task.status === 'RUNNING' || task.status === 'REATTEMPTING')) {
                                            tasksTerminated++;
                                            if (task.taskType === 'TRANSCODE' && task.status === 'COMPLETED') {
                                                canBePublished = true;
                                            }
                                            if (task.taskType === 'AUDIO_EXTRACTION' && task.status === 'LIMIT_EXCEEDED') {
                                                captioningProviderLimitReached = true;
                                            }
                                            if (task.taskType === 'SUBTITLE' && task.status === 'COMPLETED') {
                                                if (task.captionType === 'WATSON') {
                                                    file.captionStatus = CaptionTypeMessages.WATSON;
                                                } else if (task.captionType === 'EMBEDDED') {
                                                    file.captionStatus = CaptionTypeMessages.EMBEDDED;
                                                }
                                            }
                                        }
                                    });
                                    file.progress = Math.floor(jobSummary.progress);
                                    if (file.progress === 100 || (tasksTerminated !== 0 && tasksTerminated === jobSummary.tasks.length)) {
                                        if (file.progress !== 100) {
                                            file.progress = 100;
                                            file.canBePublished = canBePublished;
                                            if (!canBePublished) {
                                                file.uploadStatus = "File processing failed, with fatal error during transcode";
                                                file.errors.push({id: 'ufe' + Date.now(), msg: UploadErrors.TRANSCODE});
                                                batch.errors.push({
                                                    id: 'ube' + Date.now(),
                                                    msg: UploadErrors.TRANSCODE
                                                });
                                            } else {
                                                file.uploadStatus = "File processing complete, but with some non-fatal errors";
                                            }
                                        }
                                        else {
                                            file.uploadStatus = "File processing complete";
                                            file.canBePublished = canBePublished;
                                        }
                                        transcodedCount++;
                                        var watsonLimitError = $filter('filter')(file.errors, {watsonError: true}, true)[0];
                                        if (captioningProviderLimitReached && !watsonLimitError) {
                                            file.errors.push({
                                                id: 'ufe' + Date.now(),
                                                msg: UploadErrors.WATSON_LIMIT_REACHED,
                                                watsonError: true
                                            });
                                            scope.errors.push({
                                                id: 'ue' + Date.now(),
                                                msg: UploadErrors.WATSON_LIMIT_REACHED,
                                                watsonError: true
                                            });
                                        }
                                    } else {
                                        var processingTime = jobSummary.inQueueTasks.estimatedTimeToComplete;
                                        file.uploadStatus = "Processing file... " + Math.floor((processingTime / 1000) / 60) + " min " + Math.ceil((processingTime / 1000) % 60) + " sec remaining";
                                    }
                                    totalProgress += file.progress;
                                }
                            });
                            if (batch.size == 0 && !batch.cancelled) {
                                batch.size = batchSummary.jobSummary.length;
                                batch.uploadedFilesCnt = batch.size;
                            }
                            batch.progress = Math.floor(totalProgress / batch.size);
                            batch.transcodedCnt = transcodedCount;
                        }
                    };

                    var atmosphereSetup = function () {

                        var request = {
                            url: scope.notificationUrl + scope.account.login,
                            contentType: 'application/json',
                            logLevel: 'debug',
                            transport: 'websocket',
                            fallbackTransport: 'streaming',
                            trackMessageLength: true,
                            reconnectInterval: 5000,
                            enableXDR: true,
                            timeout: 300000,
                            shared: true
                        };

                        request.onOpen = function(response) {
                            console.log('Atmosphere connected using ' + response.transport);
                        };

                        request.onMessage = function (response) {

                            try{

                                var message = JSON.parse(response.responseBody);

                                var batch;

                                if (message.messageType === 'transcode') {

                                    processBatchSummary(message.messageBody);

                                } else if (message.messageType === 'publish') {
                                    var baseFile = message.messageBody,
                                        assetId = message.assetId;

                                    batch = $filter('filter')(scope.batches, {batchId: baseFile.batch.batchId}, true)[0];

                                    if (batch) {

                                        var file = $filter('filter')(batch.files, {fileId: baseFile.fileId}, true)[0];

                                        if (file && (baseFile.publishStatus === 'COMPLETE')) {
                                            file.publishedTime = new Date().getTime();
                                            tick();
                                            file.aid = assetId;
                                            file.published = true;
                                        } else if (baseFile.publishStatus === 'ERROR') {
                                            file.errorOnPublish = true;
                                            file.publishMessage = 'Publishing failed';
                                            file.errors.push({
                                                id: 'ufe' + Date.now(),
                                                msg: UploadErrors.PUBLISH_FILE.formatMessage({name: file.name})
                                            });
                                        }
                                    }
                                }
                            }catch(err) {
                                console.log(err.message);
                            }
                        };

                        request.onClientTimeout = function (response) {
                            setTimeout(function () {
                                atmosphereService.subscribe(request);
                            }, request.reconnectInterval);
                        };

                        atmosphereService.subscribe(request);

                    };

                    var tick = function () {
                        scope.currentTime = new Date().getTime();
                    };

                    $interval(tick, 60000);

                    // Update Metadata Operations

                    scope.updateFileMetadata = function (file) {
                        var fileId = file.fileId ? file.fileId : file.mediacloudFileId;
                        file.subtitles = [
                             {
                                 'language': 'English',
                                 'listOrder': 1,
                                 'enabledByDefault': true
                             }
                         ];
                        var baseFileResource = new BaseFileService.AddMetadata({
                            id: fileId,
                            title: file.metadata.title,
                            contributor: file.metadata.contributor,
                            description: file.metadata.description,
                            isStudentUpload: false,
                            subtitles: file.subtitles
                        });
                        baseFileResource.$save(function () {
                            var baseFileCaptionResource = new BaseFileService.SendForCaptioning({
                                id: fileId,
                                send: file.sendForCaptioning
                            });
                            baseFileCaptionResource.$save(function () {
                                file.metadataForm.$setPristine();
                                file.metadataApplied = true;
                            }, function () {
                                file.metaErrors.push({id: 'fme' + Date.now(), msg: UploadErrors.SEND_FILE_CAPTION});
                            });
                        }, function () {
                            file.metaErrors.push({id: 'fme' + Date.now(), msg: UploadErrors.UPDATE_FILE_METADATA});
                        });
                    };

                    scope.selectThumbnail = function (file, thumbnail) {
                        var thumbnailResource = new BaseFileService.Thumbnail({
                            id: file.fileId,
                            thumbnailId: thumbnail.id
                        });
                        thumbnailResource.$save(function () {
                            file.selectedThumbnail = thumbnail;
                        }, function () {
                            file.metaErrors.push({id: 'fme' + Date.now(), msg: UploadErrors.CHOOSE_THUMBNAIL});
                        });
                    };

                    scope.updateBatchMetadata = function (batch) {
                        var batchResource = new BatchService.AddMetadata({
                            id: batch.batchId,
                            prefix: batch.metadata.prefix,
                            title: batch.metadata.title,
                            contributor: batch.metadata.contributor,
                            description: batch.metadata.description
                        });
                        batchResource.$save(function () {
                            var batchCaptionResource = new BatchService.SendForCaptioning({
                                id: batch.batchId,
                                send: batch.sendForCaptioning
                            });
                            batchCaptionResource.$save(function () {
                                if (batch.files) {
                                    batch.files.forEach(function (file) {
                                        file.sendForCaptioning = batch.sendForCaptioning;
                                    });
                                }
                            }, function () {
                                batch.metaErrors.push({id: 'bme' + Date.now(), msg: UploadErrors.SEND_BATCH_CAPTION});
                            });
                            // Apply the changes to file metadata on the front-end
                            if (batch.files) {
                                batch.files.forEach(function (file) {
                                    if (batch.metadata.contributor) file.metadata.contributor = batch.metadata.contributor;
                                    if (batch.metadata.description) file.metadata.description = batch.metadata.description;
                                    if (batch.metadata.prefix) file.metadata.prefix = batch.metadata.prefix;
                                });
                            }
                            batch.metadataForm.$setPristine();
                            batch.metadataApplied = true;
                        }, function () {
                            batch.metaErrors.push({id: 'bme' + Date.now(), msg: UploadErrors.UPDATE_BATCH_METADATA});
                        });
                    };

                    // Cancel Operations

                    scope.cancelBatch = function (batch) {
                        if (batch.uploader) {
                            batch.uploader.cancelAll();
                            batch.cancelled = true;
                        }
                        BatchService.CancelBatch.erase({id: batch.batchId}, function () {
                            batch.cancelled = true;
                        }, function () {
                            batch.errors.push({id: 'ube' + Date.now(), msg: UploadErrors.CANCEL_BATCH});
                        });
                    };

                    scope.cancelFile = function (file) {
                        if (file && !file.cancelled) {
                            var batch = $filter('filter')(scope.batches, {batchId: file.batchId}, true)[0];
                            if (file.jobId) {
                                JobService.CancelJob.erase({id: file.jobId}, function () {
                                    cleanUpFileAndBatch(file, batch);
                                }, function () {
                                    file.errors.push({id: 'ufe' + Date.now(), msg: UploadErrors.CANCEL_FILE});
                                });
                            } else {
                                var fileId = file.fileId ? file.fileId : file.mediacloudFileId;
                                BaseFileService.CancelBaseFile.erase({id: fileId}, function () {
                                    cleanUpFileAndBatch(file, batch);
                                }, function () {
                                    file.errors.push({id: 'ufe' + Date.now(), msg: UploadErrors.CANCEL_FILE});
                                });
                            }
                        }
                    };

                    var cleanUpFileAndBatch = function (file, batch) {
                        file.cancelled = true;
                        batch.files = batch.files.filter(function (el) {
                            return el.mediacloudFileId !== file.mediacloudFileId;
                        });
                        batch.size = batch.files.length;
                        if (batch.uploadedFilesCnt) {
                            batch.uploadedFilesCnt--;
                        }
                        if (batch.size == 0) {
                            batch.cancelled = true;
                        } else if (batch.size === batch.transcodedCnt) {
                            batch.publishReady = true;
                        }
                    };

                    scope.selectItemForPublishing = function (obj) {
                        scope.itemSelectedForPublishing = obj.item;
                        scope.itemSelectedForPublishing.subtitles = [
                            {
                                'language': 'English',
                                'listOrder': 1,
                                'enabledByDefault': true
                            }
                        ];
                        scope.itemSelectedForPublishing.isBatch = obj.isBatch;
                        scope.itemSelectedForPublishing.inProgress = obj.inProgress;
                        scope.itemSelectedForPublishing.publishTime = new Date().getUTCMilliseconds();
                        $("#publishWindow").modal('show')
                            .on('shown.bs.modal', function () {
                                modalFocus('#publishHeading', '#returnTopublishHeading');
                                $('#returnTopublishHeading').on('focus', function () {
                                    $('#publishHeading').focus()
                                });
                            });
                    };

                    // If the user attempts to leave the page before all files are uploaded, prompt the user

                    scope.$on('$stateChangeStart', function (event) {
                        if (scope.tracker.uploadingBatches > 0) {
                            var answer = confirm("Some files are still being uploaded and these uploads will fail if you leave this page. Are you sure you want to leave ?");
                            if (!answer) {
                                event.preventDefault();
                            }
                        }
                    });

                    $window.onbeforeunload = function () {
                        if (scope.tracker.uploadingBatches > 0) {
                            return "Some files are still being uploaded and these uploads will fail if you leave this page.";
                        }
                    };

                    scope.handleFileTitleClicked = function(e, file) {
                        if(!e.target.classList.contains('deleteIcon')) {
                            file.isCollapsed = !file.isCollapsed;
                        } else {
                            scope.showDeleteConfirmModal(file);
                        }
                    }

                    scope.handleDeleteBatchClick = function(e, batch) {
                        scope.showDeleteBatchConfirmModal(batch);
                        e.stopPropagation();
                    }

                    scope.deleteAsset = function(file) {
                        console.log('will delete asset');
                        console.log('file: ', file);
                        var batch = $filter('filter')(scope.batches, {batchId: file.batchId}, true)[0];
                        BaseFileService.CancelBaseFile.erase({id: file.fileId}, function(){
                            cleanUpFileAndBatch(file, batch);
                            scope.selectedFileForDelete = null;
                        }, function(){
                            $scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.CANCEL_FILE});
                        });
                    }

                    scope.deleteBatch = function(batch) {
                        batch.files.forEach(function(file, index){
                            BaseFileService.CancelBaseFile.erase({id: file.fileId}, function(){
                                cleanUpFileAndBatch(file, batch);
                                scope.selectedBatchForDelete = null;
                            }, function(){
                                $scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.CANCEL_FILE});
                            });
                        })
                    }

                    scope.showDeleteConfirmModal = function(file) {
                        $('#delete-modal-uploader .modal-title').text('Delete Media Asset?');
                        $("#delete-modal-uploader").modal('show');
                        scope.selectedFileForDelete = file;
                    }

                    scope.showDeleteBatchConfirmModal = function(batch) {
                        $('#delete-modal-uploader .modal-title').text('Delete Batch?');
                        $('#delete-modal-uploader').modal('show');
                        scope.selectedBatchForDelete = batch;
                    }

                    scope.confirmDelete = function () {
                        //Delete asset
                        if(scope.selectedFileForDelete) {
                            scope.deleteAsset(scope.selectedFileForDelete);
                        }

                        //Delete batch
                        if(scope.selectedBatchForDelete) {
                            scope.deleteBatch(scope.selectedBatchForDelete);
                        }

                        $("#delete-modal-uploader").modal('hide');
                        scope.selectedFileForDelete = null;
                        scope.selectedBatchForDelete = null;
                    }

                    scope.closeDeleteModal = function () {
                        scope.selectedFileForDelete = null;
                        scope.selectedBatchForDelete = null;
                        $("#delete-modal-uploader").modal('hide');
                    }
                }
            }
        }

    }]);
